export default __webpack_public_path__ + "/dist/images/9451099.b98ba3423cc734105a1b026e4af5d3d7.png";